import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import {
  BarStackChart,
  COLOR_SCALE_0,
  COLOR_SCALE_40,
  COLOR_SCALE_NEGATIVE_40,
  formatData,
  Layout,
  Tabs,
  tooltipFormatter,
} from '@utilities';

import { DISPLAY_AS } from '../../utilities/helpers';
import OptionImageTable from '../OptionImageTable';

import styles from './_index.module.scss';

const MaxDiff = ({ data, displayAs = DISPLAY_AS.PERCENT.value, questionOptions }) => {
  const [selectedSegmentId, setSelectedSegmentId] = useState();
  const isDisplayAsPercent = displayAs === DISPLAY_AS.PERCENT.value;

  useEffect(() => {
    setSelectedSegmentId(data?.segments?.[0]?.id);
  }, [data?.segments]);

  const selectedSegment = useMemo(() => {
    return data?.segments?.find(({ id }) => id === selectedSegmentId);
  }, [data?.segments, selectedSegmentId]);

  const chartToDisplay = isDisplayAsPercent
    ? selectedSegment?.chartPct
    : selectedSegment?.chartCount;
  const tableToDisplay = isDisplayAsPercent
    ? selectedSegment?.tablePct
    : selectedSegment?.tableCount;

  return (
    <Layout.Flex.Column className={styles['max-diff']} gap="x-large">
      <Tabs
        aria-label="Response segment"
        onChange={setSelectedSegmentId}
        options={data.segments?.map(({ id, name }) => ({ label: name, value: id }))}
        value={selectedSegmentId}
      />
      {chartToDisplay && (
        <>
          <BarStackChart
            chartTitle={`Answer Options by ${
              displayAs === DISPLAY_AS.PERCENT.value
                ? DISPLAY_AS.PERCENT.label
                : DISPLAY_AS.COUNT.label
            }`}
            className={styles['max-diff-chart']}
            colors={[COLOR_SCALE_40, COLOR_SCALE_NEGATIVE_40, COLOR_SCALE_0]}
            series={chartToDisplay.series}
            tooltip={{
              formatter: function () {
                return tooltipFormatter({
                  data: this,
                  format: chartToDisplay?.format,
                });
              },
            }}
            xAxis={chartToDisplay?.xAxis}
            yAxis={{
              labels: {
                formatter: function () {
                  return formatData({ format: chartToDisplay?.format, value: this.value });
                },
              },
              max: isDisplayAsPercent ? 1 : undefined,
            }}
          />
          {tableToDisplay && (
            <>
              <hr />
              <OptionImageTable
                columns={tableToDisplay.columns}
                data={tableToDisplay.data}
                questionOptions={questionOptions}
              />
            </>
          )}
        </>
      )}
    </Layout.Flex.Column>
  );
};

MaxDiff.propTypes = {
  data: PropTypes.object,
  displayAs: PropTypes.string,
  questionOptions: PropTypes.arrayOf(PropTypes.object),
};

export default MaxDiff;
